var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import TrailingSvg from './trailing.icon.svg';
export const TrailingIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: TrailingSvg }));
_react_refresh_temp_1 = TrailingIcon;
$RefreshReg$(_react_refresh_temp_1, "TrailingIcon");
